import { config } from '~/config/app.config';

const IMAGE_CDN_HOSTS = new Set(['img.reflexivity.com', 'img.toggle.ai']);

export const resolveImageUrl = (imageUrl?: string) => {
  if (!imageUrl) {
    return '';
  }

  const imageRoot = config.images.root.replace(/\/+$/, '');
  if (!imageRoot) {
    return imageUrl;
  }

  try {
    const url = new URL(imageUrl);

    if (!IMAGE_CDN_HOSTS.has(url.hostname)) {
      return imageUrl;
    }

    return `${imageRoot}${url.pathname}${url.search}${url.hash}`;
  } catch {
    return imageUrl;
  }
};
